module.exports = __webpack_public_path__ + "media/images/social-bec2ccecb540135220b1e0a91097ba51.jpg";